import Constants from '../actions/types';

const initialState = {
  reports: [],
  requests: [],
  loading: false,
  message: null,
  severity: null
};

const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.REPORTS_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.REPORTS_GET_SUCCESS: {
      const newState =
        action.payload.length === 0
          ? {
              ...state,
              loading: false,
              reports: [],
              message: 'No reports were found in the system.',
              severity: 'info'
            }
          : {
              ...state,
              loading: false,
              reports: action.payload,
              message: null,
              severity: null
            };

      return newState;
    }

    case Constants.REPORTS_DOWNLOAD_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.REPORTS_GET_FAILURE: {
      const newState = {
        ...state,
        reports: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.REPORTS_DELETE_SUCCESS: {
      return state;
    }

    case Constants.REPORTS_DELETE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.REPORTS_GETREQ_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.REPORTS_GETREQ_SUCCESS: {
      const newState =
        action.payload.length === 0
          ? {
              ...state,
              loading: false,
              requests: [],
              message: 'No reports were found in the system.',
              severity: 'info'
            }
          : {
              ...state,
              loading: false,
              requests: action.payload,
              message: null,
              severity: null
            };

      return newState;
    }

    case Constants.REPORTS_GETREQ_FAILURE: {
      const newState = {
        ...state,
        requests: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.REPORTS_CREATEREQ_SUCCESS: {
      const newState = {
        ...state,
        loading: false,
        message: 'The request to generate a report was successfully submitted.',
        severity: 'info'
      };
      return newState;
    }

    case Constants.REPORTS_CREATEREQ_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.REPORTS_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default reportsReducer;
